var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0149 41.5409C36.3816 41.8002 36.8535 41.8646 37.2747 41.7066C37.694 41.5467 38.004 41.186 38.0977 40.7491C39.0864 36.104 41.485 24.3448 42.384 20.1209C42.4522 19.8011 42.3391 19.4695 42.0895 19.257C41.838 19.0444 41.4908 18.984 41.1827 19.0971C36.4128 20.8639 21.7226 26.3749 15.7182 28.596C15.3379 28.7384 15.0903 29.1031 15.102 29.5067C15.1156 29.9085 15.3867 30.2575 15.7767 30.3745C18.4698 31.1799 22.0034 32.3013 22.0034 32.3013C22.0034 32.3013 23.6551 37.2896 24.5151 39.8248C24.6243 40.1446 24.874 40.3942 25.2016 40.48C25.5311 40.5658 25.8802 40.4761 26.1259 40.244C27.5086 38.9394 29.6459 36.9211 29.6459 36.9211C29.6459 36.9211 33.7099 39.8989 36.0149 41.5409ZM23.4894 31.6694L25.4005 37.9702L25.8256 33.9803C25.8256 33.9803 33.2029 27.3246 37.4112 23.5316C37.5341 23.4205 37.5497 23.2332 37.4483 23.1026C37.3469 22.9719 37.1597 22.9407 37.0212 23.0304C32.1459 26.1428 23.4894 31.6694 23.4894 31.6694Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.4e9712525c4d5dc62dd5cee980b4de9c.svg";
export { ForwardRef as ReactComponent };